import React from 'react';
import styled, { keyframes } from 'styled-components';
import { LoaderDarkIcon } from '../../assets/icons';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoaderWrap = styled.span<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex-shrink: 0;
  animation: ${spin} 1s linear infinite;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export type LoaderProps = {
  size?: number;
  className?: string;
};

const Loader = ({ size = 24, className }: LoaderProps) => (
  <LoaderWrap $size={size} className={className} aria-hidden role="status">
    <LoaderDarkIcon />
  </LoaderWrap>
);

export default Loader;
